<template>
  <div class="shortcuts">
    <div class="title row">
      <div class="grid-12">
        Atalhos
        <strong>rápidos</strong>
      </div>
    </div>
    <div class="container">
      <div class="content row">
        <!-- <a :href="user.ns_oportunidade ||
          'https://nscommunity.netsupport.com.br/t/temos-vagas-cola-na-netsupport/2202#utm_source=Portal&utm_medium=button&utm_campaign=TemosVagas'
          " target="_blank" class="column icon icon-4">
          <div class="title column align-center">
            <i class="far fa-handshake"></i>
            Quero mais
            <br />Oportunidades
          </div>
        </a> -->
        <a :href="user.ns_academy" target="_blank" class="column icon icon-1">
          <div class="title column align-center">
            <i class="fas fa-user-graduate"></i>
            Ir para o
            <br />NS Academy
          </div>
        </a>
        <!-- TODO - Colocar o link para o extrato financeiro -->
        <a href="/supporter/extrato" class="column icon icon-2">
          <div class="title column align-center">
            <i class="fas fa-money-check-alt"></i>
            Extrato e<br /> Nota Fiscal
          </div>
        </a>
       <!--  <a :href="user.ns_community" target="_blank" class="column icon icon-3">
          <div class="title column align-center">
            <i class="fas fa-users" />
            Ir para o
            <br />NS Community
          </div>
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Shortcuts",
  components: {},
  methods: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.shortcuts {
  background: $white;
  box-shadow: $shadow;
  border-radius: 23px;
  padding: 32px 35px;
  max-height: 225px;

  .container {
    overflow-x: auto;

    .content {
     /*  @media (min-width: $large) {
        min-width: 650px;
      } */

      /* @media (max-width: $small) {
        min-width: 500px;
      } */
    }
  }

  .title {
    font-size: 26px;
    font-weight: 400;
    margin-bottom: 30px;
  }

  .icon {
    margin-top: 20px;
    margin-right: 30px;

    text-align: center;
    padding-bottom: 10px;
    color: $font-color;

    .title {
      font-size: 17px;

      @media (max-width: $large) {
        font-size: 14px;
      }

      &:hover i {
        background-color: $client-1;
      }

      i {
        background: $supporter-1;
        margin-bottom: 12px;
        border-radius: 60%;
        width: 60px;
        height: 60px;
        line-height: 66px;
        font-size: 33px;
        color: white;
      }
    }

    /*  &-1 {
      background: url(../assets/img/ico_ns_academy.svg) no-repeat top center;
      background-size: 60px 60px;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
      @media (max-width: $large) {
        background-size: 45px 45px;
      }
    }

    &-2 {
      background-size: 60px 60px !important;
      background: url(../assets/img/payment.png) no-repeat top center;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
      @media (max-width: $large) {
        background-size: 45px 45px !important;
      }
    }

    &-3 {
      background: url(../assets/img/ico_ns_community.svg) no-repeat top center;
      background-size: 60px 60px;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
      @media (max-width: $large) {
        background-size: 45px 45px;
      }
    }
    &-4 {
      background-size: 60px 60px !important;
      background: url(../assets/img/oportunity.png) no-repeat top center;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
      @media (max-width: $large) {
        background-size: 45px 45px !important;
      }
    } */
  }
}</style>
